import React from 'react';
import { Navbar, NavItem } from "react-bootstrap";
import {links} from '../../content/footer.yaml';
import navigate from '../../../navigation';

class Footer extends React.Component {

    render() {
        return (<Navbar className="footer-wrapper" collapseOnSelect>
            <Navbar.Collapse>
		        <div className="footer">
                    {links.map((link, i) => {
                        return <NavItem className="footer-item" key={i} eventKey={i} onClick={()=> navigate(link.url)} target="_blank">
                            {link.copy}
                        </NavItem>
                    })}
		        </div>
            </Navbar.Collapse>
        </Navbar>);
	}
}


export default Footer;
